export default "__VITE_ASSET__DuoWr$Xv__"